import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const AccountManagementPage = () => <ModuleDetailPage moduleId="account-management" />;

export default AccountManagementPage;
